<!--异常情况分析-->
<template>
	<div>
		<h3>异常情况分析</h3>
		<div>
            <div class="lines">
                <el-form ref="form" :model="form" inline :rules="rules">
                    <el-form-item prop="date" style="width: 150px;">
						<el-radio-group v-model="form.date">
                            <el-radio-button label="本月"></el-radio-button>
                            <el-radio-button label="本年"></el-radio-button>
                        </el-radio-group>
					</el-form-item>
                    <el-form-item prop="makeTime" style="width: 360px;padding-top: 1px;">
                        <el-date-picker
                        v-model="form.makeTime" clearable
                        type="daterange"
                        range-separator="-"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期">
                        </el-date-picker>
					</el-form-item>
                    <el-form-item prop="productForm.Productname" style="width: 210px;">
                        <el-input placeholder="全部产品" :value="form.productForm.Productname" @focus="productfocus"></el-input>
                    </el-form-item>
                    <el-button @click="restForm" type="warning" style="margin-top: 1px;">重 置</el-button>
                </el-form>
                <div class="map">
                    <div :style="{height:'500px',width:'50%'}" ref="eChart1" id="echart1"></div>
                    <div :style="{height:'500px',width:'50%',float:'right'}" ref="eChart2" id="echart2"></div>
                </div>
            </div>
            <div style="display:flex">
                <div class="table">
                    <el-button type="primary" style="margin-bottom: 15px;">导 出</el-button>
                    <el-table border>
                        <el-table-column align="center" property="DataId" label="时间"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="包装关系"></el-table-column>
                        <el-table-column align="center" property="Productname" label="调库"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="入库"></el-table-column>
                        <el-table-column align="center" property="Productname" label="出库"></el-table-column>
                    </el-table>
                </div>
                <div class="table">
                    <el-button type="primary" style="margin-bottom: 15px;">导 出</el-button>
                    <el-table border>
                        <el-table-column align="center" property="DataId" label="时间"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="生产入库"></el-table-column>
                        <el-table-column align="center" property="Productname" label="退货入库"></el-table-column>
                        <el-table-column align="center" property="Productcode" label="调拨入库"></el-table-column>
                        <el-table-column align="center" property="Productname" label="经销商采购入库"></el-table-column>
                    </el-table>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import echarts from "echarts";//引入图表

export default {
	data(){
		return {
            form:{
                date:'本月',
                makeTime:'',
                productForm:{
					Productcode:'',
					Productname:'',
					Norms:''
				},
            },
            rules: {
        		makeTime:[
          			{ required: true, message: '请选择时间', trigger: 'change' }
        		]
			},
            option1:{
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    top: 'center',
                    right:20,
                    data: ['入库异常', '出库异常', '非本企业数码', '调库异常', '包装关系建立异常', '其他']
                },
                series: [
                    {
                        name: '查询类型',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: ['35%', '50%'],

                        label: {
                             show: false
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: 0,name: '入库异常'},
                            {value: 0,name: '出库异常'},
                            {value: 0,name: '非本企业数码'},
                            {value: 0,name: '调库异常'},
                            {value: 0,name: '包装关系建立异常'},
                            {value: 0,name: '其他'}
                        ]
                    }
                ]
            },
            option2:{
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b}: {c} ({d}%)'
                },
                legend: {
                    orient: 'vertical',
                    top: 'center',
                    right:20,
                    data: ['生产入库', '退货入库', '调拨入库', '经销商采购入库']
                },
                series: [
                    {
                        name: '查询类型',
                        type: 'pie',
                        selectedMode: 'single',
                        radius: ['35%', '50%'],

                        label: {
                             show: false
                        },
                        labelLine: {
                            show: false
                        },
                        data: [
                            {value: 0,name: '生产入库'},
                            {value: 0,name: '退货入库'},
                            {value: 0,name: '调拨入库'},
                            {value: 0,name: '经销商采购入库'}
                        ]
                    }
                ]
            }
		};
	},
	mounted : function(){
		var user = JSON.parse(sessionStorage.getItem('user'));
        this.initEcharts()
        
        var elementResizeDetectorMaker = require("element-resize-detector");//导入
        // 创建实例
        var erd = elementResizeDetectorMaker();
        // 创建实例带参
        var erdUltraFast = elementResizeDetectorMaker({
                        strategy: "scroll", //<- For ultra performance.
                        callOnAdd: true,
                        debug: true
                    });
        //监听id为test的元素 大小变化
        erd.listenTo(document.getElementById("echart1"), function(element) {
             let  myChart1 = echarts.init(document.getElementById('echart1'));
             myChart1.resize();
        });
        erd.listenTo(document.getElementById("echart2"), function(element) {
             let  myChart2 = echarts.init(document.getElementById('echart2'));
             myChart2.resize();
        });
        
	},
	methods: {
        //初始化
        initEcharts(){
            let  myChart1 = echarts.init(this.$refs.eChart1);
            myChart1.setOption(this.option1);

            let  myChart2 = echarts.init(this.$refs.eChart2);
            myChart2.setOption(this.option2);
        },
        productfocus(){//获取商品
			this.productVisible=true;
			var user = JSON.parse(sessionStorage.getItem('user'));
			this.$axios({
				method: 'post',
				url:'/FW/Product.ashx',
				params: {
					action:"query",
					cid:user.QyNum
				}
				}).then(res=>{
				if(res.Code==0){
					this.productData=res.DataList;
				}else{
					this.$message({
					showClose: true,
					message: res.Msg,
					type: "warning"
					});
				}      
			})
        },
       
        restForm(){//重置表单
			this.$nextTick(()=>{
				this.$refs['form'].resetFields()
			})
		},
	}
}
</script>

<style scoped>
.lines{
    width: 100%;
    background: #f8f8f8;
    padding: 10px;
    margin-bottom: 20px;
}
.table{
    flex:1;
    padding: 10px;
    background: #f8f8f8;
}
.map{
    margin-top: 20px;
    padding: 10px 10px;
    background: #f8f8f8;
    overflow:hidden;
    zoom:1;
}
.map div{
    float: left;
}
</style>


// WEBPACK FOOTER //
// src/pages/anomalyData.vue